import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import API from "../config/axios";
import { api_paths } from "../config/api.paths";
import defaultAvatar from "../assets/images/contactus/defaultavatar.png";
import stars from "../assets/images/committee/Group 1321314203.png"; // ⭐ imported decorative image

const base_url = "https://preview.gujaratisamajtampabay.com:3071";

function CommitteeDetails() {
  const { id } = useParams();
  const [member, setMember] = useState(null);

  const fetchCommitteeMember = async () => {
    try {
      const response = await API.get(
        `${api_paths.committee.GET_COMMITTEE_MEMBER_DETAIL}/${id}`
      );

      const data = response?.data?.payload;
      setMember(data);
    } catch (error) {
      console.error("Error fetching member:", error);
    }
  };

  useEffect(() => {
    fetchCommitteeMember();
  }, [id]);

  if (!member) return <p>Loading...</p>;

  return (
    <div className="committee-container">
      <div className="committee-header">
        {/* LEFT SIDE IMAGE */}
        <img
          className="committee-photo"
          src={
            member.picture_path
              ? `${base_url}${member.picture_path}`
              : defaultAvatar
          }
          alt={member.name}
        />

        {/* RIGHT SIDE DETAILS */}
        <div className="committee-info">
          <h2 className="committee-name">{member.name}</h2>

          <span className="committee-position">{member.position}</span>

          <div className="committee-details-list">
            {member.phone && (
              <p>
                📞 <span>{member.phone}</span>
              </p>
            )}

            {member.email && (
              <p>
                📧 <span>{member.email}</span>
              </p>
            )}

            {/* BIOGRAPHY SECTION */}
            <div className="committee-bio">
              <h3>Biography</h3>
              <p>{member.biography}</p>
            </div>
          </div>
        </div>

        {/* DECORATION ICON RIGHT SIDE */}
        <img src={stars} alt="icon" className="committee-stars" />
      </div>
    </div>
  );
}

export default CommitteeDetails;
